import { useCallback } from 'react';
import styled from '@emotion/styled';
import { ButtonSet } from '@trinity/chat-components/components/Modal/ButtonSet.js';
import type { ModalProps } from '@trinity/chat-components/components/Modal/Modal.js';
import Prompt from '@trinity/chat-components/components/Modal/Prompt.js';
import Button from '@trinity/chat-components/components/presentation/Button/index.js';
import useDeleteFileMutation from '@/containers/Workspace.File/hooks/useDeleteFile';

type Props = {
  fileId: number;
  workspaceId: number;
} & Pick<ModalProps, 'open' | 'onClose'>;

export const DeleteFilePrompt = ({
  fileId,
  workspaceId,
  onClose,
  open,
}: Props) => {

  const mutation = useDeleteFileMutation();

  const handleSave = useCallback(() => {
    return mutation.mutateAsync({
      fileId,
      workspaceId,
    }, {
      onSuccess: () => {
        onClose();
      },
    });
  }, [fileId, mutation, onClose, workspaceId]);

  const Footer = useCallback(() => {
    return (
      <ButtonSet>
        <StyledButton
          disabled={mutation.isPending}
          color="destructive"
          onClick={onClose}
          variant="brick">
          Cancel
        </StyledButton>
        <StyledButton
          disabled={mutation.isPending}
          color="primary"
          onClick={handleSave}
          variant="brick">
          Remove
        </StyledButton>
      </ButtonSet>
    );
  }, [handleSave, mutation.isPending, onClose]);

  return (
    <Prompt
      body="Are you sure you want to remove this file?"
      footer={Footer()}
      header="Remove File"
      onClose={onClose}
      visible={open} />
  );
};

const StyledButton = styled(Button)({
  minWidth: 130,
});